import { clientCode } from "$lib/stores/store";
import { writable } from "svelte/store";

// Inisialisasi variabel state darkGrayText
export const darkGrayText = writable<string>(""); // Inisialisasi dengan nilai awal string kosong

// Cek clientCode dan atur nilai darkGrayText berdasarkan kondisi
clientCode.subscribe((value) => {
    darkGrayText.set(value === "catchmeup" ? "#5d3562" : "#18191d"); // Atur nilai darkGrayText sesuai dengan kondisi
});

export function isReandraCode(code: string, original: string, expect: string) {
    if (code === "reandabernardi") {
        return expect;
    } else {
        return original;
    }
}
